import React, { Component } from 'react';
import { Input, Button, Table, Modal, Form, Popconfirm, message, Card } from 'antd';
import { Redirect } from 'react-router';
import './style.css';
import TypeEdit from './typeedit';
import TreeMenu from '../../../components/backEnd/treeMenu';

class ProductType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      defaultExpandAllRows: true, //是否默认展开树形结构
      productTypeData: [],
      treeData: [],
      redirect: false,
      isLoading: true,
      formParams: {
        goods_category_name: ''
      },
      search: {
        page_size: 100,
        current_page: 1
      },
      editInfo: {
        id: null,
        goods_category_name: null,
        superior_id: null,
      },
      parent_id: '', //类别父级id
      goods_category_hierarchy: 0 // 当前创建的分类的层级
    };
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      this.loadList();
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 将获取的商品类型列表格式化
  getChildData = (data, pid) => {
    const children = [];
    data.map((item) => {
      if (item.superior_id === pid) {
        children.push({
          goods_category_name: item.goods_category_name,
          id: item.id,
          superior_id: item.superior_id,
          children: this.getChildData(data, item.id)
        });
      }
    });
    return children;
  }

  //商品类型查询接口
  loadList = () => {
    window.api('goods.getcategorylist', this.state.search).then((res) => {
      const treeData = res.goods_category_list;
      const arr = [];
      if (treeData.length > 0) {
        treeData.forEach(item => {
          if (item.superior_id === 0) {
            arr.push({
              goods_category_name: item.goods_category_name,
              id: item.id,
              superior_id: item.superior_id,
              children: this.getChildData(treeData, item.id)
            });
          }
        });
        this.setState({treeData, isLoading: false, productTypeData: arr});
      } else {
        this.setState({productTypeData: arr});
      }
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }

  //新增商品类型
  addTypeEvent = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const pid = this.state.parent_id === '' ? 0 : this.state.parent_id;
        this.setState({formParams: values});
        if (this.state.goods_category_hierarchy === 3) {
          message.warning('只能创建三级分类');
          return false;
        }
        Object.assign(this.state.formParams, {superior_id: pid, goods_category_hierarchy: this.state.goods_category_hierarchy + 1});
        window.api('goods.addcategory', this.state.formParams).then((res) => {
          message.success(res.service_error_message);
          this.loadList();
        }).catch((error) => {
          if (error.service_error_code === 'EPS000000801') {
            this.setState({redirect: true});
          }
          message.error(error.service_error_message);
        });
      }
    });
  }

  // 删除分类
  delEvent = (id) => {
    window.api('goods.delcategory', {id}).then((res) => {
      message.success(res.service_error_message);
      this.loadList();
      id === this.state.parent_id ? this.setState({parent_id: ''}) : null; // 如果删除目录选中项，重置parent_id
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 编辑
  editEvent = (item) => {
    const editInfo = {
      goods_category_name: item.goods_category_name,
      id: item.id,
      superior_id: item.superior_id
    };
    this.setState({editInfo, visible: true});
  }

  // 取消
  cancelEvent = () => {
    this.setState({visible: false});
    this.loadList();
  }

  // 编辑保存后触发
  modifyEvent = (e) => {
    this.setState({visible: false});
    this.loadList();
  }

  // 双向绑定商品名称
  goodsNameEvent = (e) => {
    const formParams = Object.assign({}, this.state.formParams, {goods_category_name: e.target.value});
    this.setState({formParams});
  }

  // 获取父级分类目录
  selParentEvent = (value, hierarchy) => {
    this.setState({
      parent_id: value,
      goods_category_hierarchy: hierarchy
    }, () => {
      this.loadList();
    });
  }

  // 重置
  resetEvent = () => {
    this.props.form.resetFields();
    this.setState({
      formParams: {
        goods_category_name: ''
      },
      parent_id: ''
    });
  }

  render() {
    const columns = [
      {
        title: '类别名称',
        dataIndex: 'goods_category_name',
        key: 'goods_category_name'
      },
      {
        title: '操作',
        key: 'operation',
        width: 160,
        render: (_, record) => (
          <div className="type-list-actions">
            <Button type="link" size="small" onClick={() => this.editEvent(record)}>编辑</Button>
            <Popconfirm title="是否要删除此分类？" onConfirm={() => this.delEvent(record.id)} okText="确定" cancelText="取消">
              <Button type="link" size="small">删除</Button>
            </Popconfirm>
          </div>
        )
      }
    ];
    const {getFieldDecorator} = this.props.form;
    const {
      visible, formParams, redirect, treeData, isLoading, defaultExpandAllRows, productTypeData, editInfo
    } = this.state;
    if (redirect) {
      return (<Redirect to="/login" />);
    }
    return (
      <div className="type-list-page">
        {visible && (
          <Modal title="编辑分类" onCancel={this.cancelEvent} visible={visible} footer={null} width={480} className="type-edit-modal">
            <TypeEdit editInfo={editInfo} treeData={treeData} onClick={this.cancelEvent} modifyEvent={this.modifyEvent} />
          </Modal>
        )}
        <div className="type-list-layout">
          <Card title="添加分类" className="type-list-form-card">
            <Form onSubmit={this.addTypeEvent} className="type-list-form" name="form">
              <Form.Item label="分类名称">
                {getFieldDecorator('goods_category_name', {
                  initialValue: formParams.goods_category_name || '',
                  rules: [{ required: true, message: '请输入分类名称' }]
                })(<Input onChange={this.goodsNameEvent} placeholder="请输入分类名称" className="type-list-input" />)}
              </Form.Item>
              <Form.Item label="父级分类">
                <TreeMenu selParentEvent={(value, hierarchy) => this.selParentEvent(value, hierarchy)} parent_id={this.state.parent_id} treeData={treeData} />
              </Form.Item>
              <Form.Item className="type-list-form-actions">
                <Button type="primary" htmlType="submit">添加</Button>
                <Button onClick={this.resetEvent}>清空</Button>
              </Form.Item>
            </Form>
          </Card>
          <Card title="分类列表" className="type-list-table-card">
            <Table
              loading={isLoading}
              rowKey={(record) => record.id}
              defaultExpandAllRows={defaultExpandAllRows}
              columns={columns}
              dataSource={productTypeData}
              className="type-list-table"
              pagination={false}
              scroll={{x: 1000}}
            />
          </Card>
        </div>
      </div>
    );
  }
}
export default Form.create()(ProductType);



// WEBPACK FOOTER //
// ./src/containers/backEnd/productType/typelist.jsx